import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { HeroLayout } from '@change/ds-core-ui/HeroLayout';
import { Text } from '@change/ds-core-ui/Text';
import { VictoryFlagIllustration } from '@change/ds-illustrations/VictoryFlagIllustration';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { Waypoint } from '#src/app/shared/components/scroll';

import { useContributeSection } from './hooks/useContributeSection';

export const ContributeSection: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const {
		actions: { onCtaClick, onSectionView },
	} = useContributeSection();

	return (
		<HeroLayout
			variant="1/2"
			data-testid="homepage-contribute-section"
			reverseMd
			className="bg-background-raised text-typography-strong"
			media={
				<div className="bg-background-overlay md:bg-background-raised h-full">
					<VictoryFlagIllustration
						alt={translate('corgi.homepage.contribute_section.image.alt_text_group')}
						loading="lazy"
						className="aspect-video h-full w-full object-contain"
					/>
				</div>
			}
		>
			<div className="flex flex-col items-start gap-5 p-6 md:gap-6 md:p-12">
				<div>
					<Waypoint onEnter={onSectionView} />
					<Text as="h2" data-qa="contribute-section-title" variant="heading" size="large">
						<Translate value="corgi.homepage.contribute_section.title_alt" />
						<br />
						<Translate value="corgi.homepage.contribute_section.subtitle_alt" />
					</Text>
				</div>

				<Text variant="body">
					<Translate value="corgi.homepage.contribute_section.description_alt" />
				</Text>

				<Button data-qa="homepage-contribute-section-cta" onClick={onCtaClick} as="a" href="/member/join">
					<Translate value="corgi.homepage.contribute_section.cta_btn" />
				</Button>
			</div>
		</HeroLayout>
	);
};
